import { gql } from 'graphql-request';
import {
  ProductBlocked,
  ProductBrandID,
  ProductBrandLocalizedName,
  ProductBrandName,
  ProductBrandUUID,
  ProductCreatedAt,
  ProductFavorite,
  ProductID,
  ProductImageFile,
  ProductImageID,
  ProductImageUUID,
  ProductMaxFileCreatedAt,
  ProductName,
  ProductNanoID,
  ProductNda,
  ProductPreviewModelFile,
  ProductPreviewModelID,
  ProductPreviewModelName,
  ProductPreviewModelSize,
  ProductPreviewModelUUID,
  ProductRenderTypeID,
  ProductRenderTypeName,
  ProductTagID,
  ProductTagName,
  ProductUUID
} from '../productsTypes';

export interface FetchProductsQueryResponse {
  blocked: ProductBlocked;
  favorite: ProductFavorite;
  id: ProductID;
  uuid: ProductUUID;
  nanoId: ProductNanoID;
  name: ProductName;
  nda: ProductNda;
  sku: ProductUUID;
  createdAt: ProductCreatedAt;
  updatedAt: ProductCreatedAt;
  renderTypes: {
    id: ProductRenderTypeID;
    name: ProductRenderTypeName;
  }[];
  image: {
    id: ProductImageID;
    uuid: ProductImageUUID;
    file: ProductImageFile;
  };
  maxFile: {
    createdAt: ProductMaxFileCreatedAt;
  };
  previewModel: {
    id: ProductPreviewModelID;
    uuid: ProductPreviewModelUUID;
    file: ProductPreviewModelFile;
    size: ProductPreviewModelSize;
    name: ProductPreviewModelName;
  };
  brand: {
    id: ProductBrandID;
    uuid: ProductBrandUUID;
    name: ProductBrandName;
    localizedName: ProductBrandLocalizedName;
  };
  tags: {
    id: ProductTagID;
    localizedName: ProductTagName;
  }[];
}

export const FETCH_PRODUCTS_QUERY = gql`
  query Products(
    $filters: ProductsFilters
    $sort: [ProductsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    products(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        blocked
        favorite
        id
        uuid
        nanoId
        sku
        name
        nda
        createdAt
        updatedAt
        renderTypes {
          id
          name
        }
        image {
          id
          uuid
          file
        }
        maxFile {
          createdAt
        }
        previewModel {
          id
          uuid
          file
          size
          name
        }
        brand {
          id
          uuid
          name
          localizedName
        }
        tags {
          id
          localizedName
        }
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
